<template>
  <div class="container-fluid">
    <TheHeader :stationName="viewName" />
    <div class="ps-4 pe-4 pt-3">
      <StringPeelForm
        :station-id="stationId"
        :table-url="tableUrl"
      ></StringPeelForm>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import TheHeader from "@/components/layouts/TheHeader.vue";
import StringPeelForm from "@/components/stringpeel/StringPeelForm.vue";

const stationId = 11;
const viewName = "String Peel Test";
const tableUrl = `/Material/GetLastStringPeel?num=10`;

onMounted(() => {
  document.title = viewName;
});
</script>
